export default __webpack_public_path__ + "assets/images/0285e227e25428ab5685b6f78a50a99f.png";